// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__1P8_s","headTitle":"style_headTitle__1aO4q"};